// @react
import React from 'react'
import MemberResources from 'modules/benefitsCenter/components/MemberResources'
/**
 * 2.0.0.11 MyATD - Dashboard - My Sites & Resource Module
 * https://www.figma.com/file/jCo0D2EYkVbuBX1TjR1enA/ATD-MyATD-Desktop-2020?node-id=3528%3A41884
 *
 * endpoint: user/profile
 * response: UserProfileDTO
 * response namespaces: User/Benefits
 */

const BenefitsResources = () => {
  /**
   * props
   */
  return <MemberResources />
}

export default BenefitsResources
